const actions = {
  SET_STATE: 'pages/company/users/SET_STATE',
};

export default actions;
